'use client';

import cx from 'classnames';
import { FC, useState } from 'react';
import Drawer from './Drawer';
import IconPlusFaqDrawer from './IconPlusFaqDrawer';

export interface FaqDrawerProps {
  question: string;
  questiontwo?: string;
  answer: React.ReactNode;
  open?: boolean;
  onClick: () => void;
}

export interface FaqDrawerListProps {
  title: string;
  description: React.ReactNode;
  drawers: FaqDrawerProps[];
}

export const FaqDrawer: FC<FaqDrawerProps> = ({ question, questiontwo, answer, open, onClick }) => {
  const renderTrigger = () => (
    <button onClick={onClick} className="w-full flex justify-between items-center gap-2 py-4 px-2 md:px-3">
      <div className="flex flex-col gap-0">
        <p className="text-20/22 md:text-30/35 font-500 text-left">{question}</p>
        {questiontwo && <p className="text-20/22 md:text-30/35 font-500 text-left mt-0">{questiontwo}</p>}
      </div>
      <IconPlusFaqDrawer open={open} className="block" />
    </button>
  );

  return (
    <Drawer open={open} renderTrigger={renderTrigger}>
      <div className="px-2 md:px-3 pb-4">{answer}</div>
    </Drawer>
  );
};

const FaqDrawerList: FC<FaqDrawerListProps> = ({ title, description, drawers = [] }) => {
  const [activeDrawerIndex, setActiveDrawerIndex] = useState<number | null>(null);

  const header = (
    <div className="flex flex-col items-center justify-center gap-2 md:gap-4">
      <h2 className="text-30/35 md:text-56/65 font-500 tracking-tight">{title}</h2>
      {description}
    </div>
  );

  const drawerGrid = (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-x-gutter-mobile md:gap-x-gutter-desktop">
      <div className="md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
        <div className="-mx-2 md:-mx-3">
          {drawers.map((drawer, index) => (
            <div
              key={index}
              className={cx({
                'border-t-2 border-solid border-gray-100': index > 0,
              })}
            >
              <FaqDrawer
                {...drawer}
                onClick={() => {
                  if (index === activeDrawerIndex) {
                    setActiveDrawerIndex(null);
                  } else {
                    setActiveDrawerIndex(index);
                  }
                }}
                open={index === activeDrawerIndex}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="my-8 md:my-22 px-container-mobile md:px-container-desktop flex flex-col gap-3 md:gap-8">
      <div className="mx-auto max-w-grid flex flex-col gap-2 md:gap-8">
        {header}
        {drawerGrid}
      </div>
    </div>
  );
};

export default FaqDrawerList;
